import { useQuery } from '@tanstack/react-query';
import { getSolvencyInfo } from '@/api/solvencyInfo/solvencyInfo';

export const useGetSolvencyInfo = () => {
  const { isLoading, isFetching, data } = useQuery({
    queryKey: ['solvency-info'],
    queryFn: async () => getSolvencyInfo(),
  });

  return {
    initializing: isLoading || isFetching,
    solvencyInfo: data,
  };
};
